<div class="fixed bottom-4 right-4 flex flex-col gap-2 z-50">
	@for (toast of toastService.toasts$ | async; track toast.id) {
		<div
			[@toastAnimation]
			class="px-4 py-2 shadow text-white font-notosans flex flex-row items-center gap-2"
			[ngClass]="{
        'bg-green-600': toast.type === 'success',
        'bg-red-600': toast.type === 'error',
        'bg-blue-600': toast.type === 'info'
      }"
		>
			<img src="assets/images/team_peps_logo.avif" alt="Logo Team Peps" class="w-6">
			<span>{{ toast.message }}</span>
		</div>
	}
</div>
